import { Paper, Typography, Stack, Chip, Box, CircularProgress } from '@mui/material';
import { PageHeader, EmptyState } from '@shared/components';
import { useAuth } from '@core/auth/AuthProvider.jsx';

export default function ProfilePage() {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <Box sx={{ py: 6, display: 'flex', justifyContent: 'center' }}>
        <CircularProgress size={28} />
      </Box>
    );
  }

  if (!user) {
    return <EmptyState title="Profil indisponible" description="Connectez-vous pour consulter les informations du compte." />;
  }

  return (
    <>
      <PageHeader title="Mon profil" subtitle="Informations de votre compte" />
      <Paper sx={{ p: 3 }}>
        <Stack spacing={2}>
          <Typography><strong>Email :</strong> {user.email}</Typography>
          <Typography><strong>Nom :</strong> {user.displayName || '—'}</Typography>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography><strong>Rôles :</strong></Typography>
            {user.roles?.map((r) => <Chip key={r} label={r} size="small" />)}
          </Stack>
          <Typography><strong>Workspace :</strong> {user.workspace || '—'}</Typography>
        </Stack>
      </Paper>
    </>
  );
}
